import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled';

import { CtaNotifyMessage, type CtaNotifyMessageProps } from '../cta/CtaNotifyMessage.tsx';

import { DistributionFooter, type DistributionFooterProps } from './DistributionFooter.tsx';

export type FooterProps = {
	ctaNotifyMessageFooter?: CtaNotifyMessageProps;
	distributionFooter?: DistributionFooterProps;
};

const styles = cssMap({
	footer: {
		marginTop: 'auto',
	},
});

export const Footer = ({ ctaNotifyMessageFooter, distributionFooter }: FooterProps) => (
	<Stack grow="hug" xcss={cx(styles.footer)}>
		{ctaNotifyMessageFooter && <CtaNotifyMessage {...ctaNotifyMessageFooter} />}
		{distributionFooter && <DistributionFooter {...distributionFooter} />}
	</Stack>
);
